import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SubmitBlockerRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SubmitBlockerResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const submitBlocker = (request: SubmitBlockerRequest, options?: CashRequestOptions) =>
  post<SubmitBlockerRequest, SubmitBlockerResponse>('/2.0/cash/submit-blocker', request, {
    ...options,
    rejectOnError: true,
  })
